module.exports = __webpack_public_path__ + "static/aso3-f48d8409d42ac31f5a4a4be17894d7ec.png";